import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {AppState} from '../../../../store/appState';
import {makeGetLocalApplication} from '../../../../store/data/localApplications/localApplicationsSelectors';
import {DevelopersServersTableRow} from './developersServersTableRow';

/*
 * Props.
 */

interface DevelopersServersTableRowContainerProps {
  serverId: number;
  localApplicationId: number;
}

/*
 * Selectors.
 */

function getLocalApplicationId(_state: AppState, props: DevelopersServersTableRowContainerProps) {
  return props.localApplicationId;
}

function getServerId(_state: AppState, props: DevelopersServersTableRowContainerProps) {
  return props.serverId;
}

const getServer = createSelector(
  [makeGetLocalApplication(getLocalApplicationId), getServerId],
  (application, serverId) => {
    if (!application) {
      return undefined;
    }
    return application?.servers?.items?.find((s) => s.id === serverId);
  },
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<DevelopersServersTableRowContainerProps>()(() => ({
  server: getServer,
}));

export const DevelopersServersTableRowContainer = connect(mapStateToProps)(DevelopersServersTableRow);
